<template>
  <formitem-wapper :formitem="formitem">
    <div class="components-input-demo-presuffix" v-if="avalid">
      <a-input readOnly
               :placeholder="placeholder"
               @click="openModal"
               :disabled="input_status"
               v-decorator="[formitem.key,formitem.fieldDecoratorOptions]">
        <a-icon slot="prefix" type="cluster" :title="placeholder" />
        <a-icon v-if="!input_status" slot="suffix" type="close-circle" @click="handleEmpty" :title="$t('button.clear')" />
      </a-input>
      <j-popup-onl-report :multi="true" @ok="callBack" :code="formitem.popupCode" :param="searchParam" :ref=" 'popup_' +formitem.key " />
    </div>
  </formitem-wapper>
</template>

<script>

import FormitemWapper from './../FormitemWapper.vue'
import { FormItemMixin } from './../FormItenMixin'
import { executeRegExp, normalRegExp } from '@comp/online/autoform/model/FieldDefVal'

export default {
  name: 'PopupWidget',
  mixins: [FormItemMixin],
  components: { FormitemWapper },
  data() {
    return {
      avalid: true,
      input_status: false,
      // popup弹框列表数据参数
      searchParam: {}
    }
  },
  mounted() {
    if (!this.formitem.orgFields || !this.formitem.destFields || !this.formitem.popupCode) {
      this.$message.error('popup参数未正确配置!')
      this.avalid = false
    }
    if (this.formitem.destFields.split(',').length != this.formitem.orgFields.split(',').length) {
      this.$message.error('popup参数未正确配置,原始值和目标值数量不一致!')
      this.avalid = false
    }
    if (this.widgetAttrs) {
      if (!this.widgetAttrs.disabled) {
        this.input_status = false
      } else {
        this.input_status = true
      }
    }

  },
  methods: {
    // 打开popup模态框
    openModal() {
      this.searchParam = this.setParams()
      this.$refs[ 'popup_' + this.formitem.key ].show()
    },
    // 根据配置的扩展参数设置popup弹框列表接口自定义参数化
    setParams() {
      let fieldExtendJson = this.formitem._formSchem.fieldExtendJson
      if (fieldExtendJson) fieldExtendJson = JSON.parse(fieldExtendJson)
      let orgParams = fieldExtendJson.popupParams
      if(!orgParams) return {}
      let obj = {}
      for(let i in orgParams) {
        obj[i] = this.changeParamsValue(orgParams[i])
      }
      return obj
    },
    // 根据表达式获取值
    changeParamsValue(defVal) {
      if(!defVal) return ''
      // 获取主表表单值
      let formData = this.getDetailData()
      let field = ''
      // 判断是否是填值规则表达式，如果是就执行填值规则
      if (normalRegExp.test(defVal)) {
        field = defVal.replace(normalRegExp, (match, code) => code.trim())
        if(!field) return ''
        return formData[field] || ''
      }else return defVal
    },
    callBack(rows) {
      let res = {}
      let field = this.formitem._propertyId
      let orgFieldsArr = this.formitem.orgFields.split(',')
      let destFieldsArr = this.formitem.destFields.split(',')
      for (let i = 0; i < orgFieldsArr.length; i++) {
        let tempDestArr = []
        for (let rw of rows) {
          let val = rw[ orgFieldsArr[ i ] ]
          if (!val) {
            val = ''
          }
          tempDestArr.push(val)
        }
        res[ destFieldsArr[ i ] ] = tempDestArr.join(',')
      }
      if (!this.formitem.subKey) {
        this.$bus.$emit('popupCallbackMinitor', res, { [ field ]: rows })
      } else {
        this.$bus.$emit('pcm' + this.formitem.subKey, res, { [ field ]: rows })
      }
    },
    handleEmpty() {
      let res = {}
      let destFieldsArr = this.formitem.destFields.split(',')
      for (let i = 0; i < destFieldsArr.length; i++) {
        res[ destFieldsArr[ i ] ] = ''
      }
      if (!this.formitem.subKey) {
        this.$bus.$emit('popupCallbackMinitor', res)
      } else {
        this.$bus.$emit('pcm' + this.formitem.subKey, res)
      }
    }
  }
}
</script>

<style scoped>
.components-input-demo-presuffix .anticon-close-circle {
  cursor: pointer;
  color: #ccc;
  transition: color 0.3s;
  font-size: 12px;
}

.components-input-demo-presuffix .anticon-close-circle:hover {
  color: #f5222d;
}

.components-input-demo-presuffix .anticon-close-circle:active {
  color: #666;
}
</style>